import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { reviewPlatformsV2Endpoints } from '@/lib/api/endpoints';
import { reviewPlatformKeys } from '@/lib/queryKeys';
import type { ReviewSettingsResponse } from '@/types/review-platform';

/**
 * GET /v2/review-platforms/settings — returns the tenant's ReviewSettings row
 * plus its PlatformConfig children. Pass `locationId` for multi-location
 * tenants; null/undefined returns the tenant-wide row (auto-created on first
 * read by the backend).
 */
export function useReviewSettings(locationId: string | null = null) {
  return useApiQuery<ReviewSettingsResponse>({
    queryKey: reviewPlatformKeys.settings(locationId),
    queryFn: () =>
      apiGet<ReviewSettingsResponse>(operationsClient, reviewPlatformsV2Endpoints.settings(), {
        params: locationId ? { locationId } : undefined,
      }),
  });
}
